import { hubSiteTree } from "@hub/services/config.service";
import { Ad, AdTheme } from "@hub/ui/ads/ad";
import React from "react";

interface CustomCodeSampleAdProps {
  borderless?: boolean;
}

export const CustomCodeSampleAd: React.FC<CustomCodeSampleAdProps> = () => {
  const fullStackPath = `/${hubSiteTree.root.urlPath}/${hubSiteTree.root.sections.codeSamples.urlPath}/full-stack`;

  return (
    <Ad
      title="Choose your own stack"
      description={[
        "Pick a frontend. Pick a backend.",
        "See how Auth0 integrates with a full-stack application of your choice.",
      ]}
      primaryAction={{
        label: "Create Custom Code Sample",
        url: fullStackPath,
      }}
      theme={AdTheme.INDIGO}
      illustration="bubbles"
    />
  );
};
